export const SET_PLAYTESTER_V2_STATE = 'playtesterV2/SET_PLAYTESTER_V2_STATE'
export const REDO_PLAYTESTER_V2 = 'playtesterV2/REDO_PLAYTESTER_V2'
export const UNDO_PLAYTESTER_V2 = 'playtesterV2/UNDO_PLAYTESTER_V2'
